/**
 * "+n" taxonomy overflow pill. CSS handles the hover/focus reveal; this adds
 * click/tap toggle, outside-click + Escape close, and aria-expanded sync.
 */
function init($) {
    $('[data-taxonomy-more]').each(function () {
        var $wrap    = $(this);
        var $trigger = $wrap.find('.blog-badge--more');

        function open() {
            $wrap.addClass('is-open');
            $trigger.attr('aria-expanded', 'true');
        }
        function close() {
            $wrap.removeClass('is-open');
            $trigger.attr('aria-expanded', 'false');
        }

        $trigger.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($wrap.hasClass('is-open')) { close(); } else { open(); }
        });

        $wrap.on('keydown', function (e) {
            if (e.key === 'Escape') { close(); $trigger.trigger('focus'); }
        });

        $(document).on('click', function (e) {
            if (!$wrap.is(e.target) && $wrap.has(e.target).length === 0) { close(); }
        });
    });
}

module.exports = { init };
